import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../..';
import useLogin from '../../hooks/useLogin';
import commonStyles from '../Common.module.css';
import Spinner from '../spinners/Spinner';
import styles from './Login.module.css';

function Login() {
    const authStore = useAuthStore();
    const navigate = useNavigate();
    const login = useLogin();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);

    const loginUser = async () => {
        await login(email, password, rememberMe);
        navigate((location.state?.pathname || "/") + (location.state?.search || ""));
    };

    return (
        <div className={styles.background}>
            <div className={styles.container} onKeyUp={e => e.key === "Enter" && loginUser()}>
                <a href="/" className={styles.logoLink}></a>
                <div className={styles.row}>
                    <label className={styles.label}>
                        EMAIL
                        <input
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            type="email"
                            placeholder="Email"
                            autoFocus
                            autoComplete="off"
                        />
                    </label>
                </div>
                <div className={styles.row}>
                    <label className={styles.label}>
                        PASSWORD
                        <input
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            type="password"
                            placeholder="Password"
                        />
                    </label>
                </div>
                <div className={styles.rowRight}>
                    <Link to="/password/forgot" className={[commonStyles.link].join(" ")}>Forgot password?</Link>
                </div>
                <div className={styles.rowHigh}>
                    <label className={styles.checkboxLabel}>
                        <input
                            checked={rememberMe}
                            onChange={e => setRememberMe(e.target.checked)}
                            type="checkbox"
                        /> Remember   me
                    </label>
                    {authStore.isLoading ? (
                        <Spinner className={styles.loginSpinner} />
                    ) : (
                        <button className={commonStyles.primaryButton} onClick={loginUser}>
                            Log In
                        </button>
                    )}
                </div>
                {authStore.error && (
                    <div className={styles.rowCenter}>
                        {authStore.error}
                    </div>
                )}
            </div>
        </div>
    );
}

export default observer(Login);